<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card class="ha-groups-center-panel">
        <div class="con-tab-ejemplo">
          <div class="jimv-btn-group" style="display: flex; flex-direction: row-reverse;">
            <vs-button type="border" style="width: 140px;" @click="launchAddNodesModal">{{ $t('HAGroup.Table.Button.AddNodes') }}</vs-button>
            <vs-button type="border" style="width: 140px;" @click="launchCreateHAGroupModal">{{ $t('HAGroup.Table.Button.CreateHAGroup') }}</vs-button>
            <vs-button class="jimv-btn-no-transition" color="dark" type="border" icon="sync" onclick="window.location.reload();"></vs-button>
          </div>
          <table>
            <thead>
            <tr>
              <td colspan="5">
                <vs-input icon="search" icon-no-border class="search-input" v-model="keyword"/>
              </td>
            </tr>
            <tr>
              <th style="display: none;">ID</th>
              <th><vs-checkbox size="small" v-model="ha_groupsCheckedStateOfAll" @change="changeAllHAGroupsCheckedState($event, !ha_groupsCheckedStateOfAll)"></vs-checkbox></th>
              <th>{{ $t('HAGroup.Table.Title.Name') }}</th>
              <th>{{ $t('HAGroup.Table.Title.Status') }}</th>
              <th>
                <div>
                  <div class="col-md-2">{{ $t('HAGroup.Table.Title.NodeName') }}</div>
                  <div class="col-md-2">{{ $t('HAGroup.Table.Title.NodeIP') }}</div>
                  <div class="col-md-1">{{ $t('HAGroup.Table.Title.NodeState') }}</div>
                  <div class="col-md-2">{{ $t('HAGroup.Table.Title.FenceDeviceIP') }}</div>
                  <div class="col-md-1">{{ $t('HAGroup.Table.Title.CPUs') }}</div>
                  <div class="col-md-1">{{ $t('HAGroup.Table.Title.InstancesCount') }}</div>
                  <div class="col-md-1">{{ $t('HAGroup.Table.Title.SystemLoad') }}</div>
                  <div class="col-md-1">{{ $t('HAGroup.Table.Title.MemoryUsage') }}</div>
                  <div class="col-md-1">{{ $t('HAGroup.Table.Title.Operation') }}</div>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="ha_group in HAGroups.slice(pageSize * (page - 1), pageSize * page)" :key="ha_group.id" :data-ha-group="JSON.stringify(ha_group)" style="height: 60px;">
              <td style="display: none;">{{ ha_group['uuid'] }}</td>
              <td>
                <vs-checkbox size="small" v-model="ha_group.checked" @change="changeHAGroupCheckedState($event, ha_group)"></vs-checkbox>
              </td>
              <td>
                <div style="display: flex; justify-content: space-between;">
                  <span style="margin: auto 0;">{{ ha_group['name'] }}</span>
                  <vs-icon class="edit_label_icon" icon-pack="m-icon" icon="ti-pencil" @click="launchChangeHAGroupModal($event, ha_group)"></vs-icon>
                </div>
              </td>
              <td>
                <span v-if="ha_group.active" style="color: #00BB00;">{{ $t('GlobalField.State.Enabled') }}</span>
                <span v-else style="color: #666666;">{{ $t('GlobalField.State.Disabled') }}</span>
              </td>
              <td v-if="ha_group.nodes.length > 0">
                <div v-for="node in ha_group.nodes" :key="node.node_id">
                  <div class="col-md-2">
                    <router-link class="jimv-link" :to="{ name: 'ComputeNodes', query: { keyword: node.node_name }}">
                      <span>{{ node.node_name }}</span>
                    </router-link>
                  </div>
                  <div class="col-md-2"><span>{{ node.ip }}</span></div>
                  <div class="col-md-1">
                    <vs-tooltip :text="$t('HAGroup.Field.ComputeNode')">
                      <span v-if="node.alive" style="color: #00BB00;">{{ $t('GlobalField.State.Online') }}</span>
                      <span v-else style="color: red;">{{ $t('GlobalField.State.Offline') }}</span>
                    </vs-tooltip>
                    |
                    <vs-tooltip :text="$t('HAGroup.Field.FenceDevice')">
                      <span v-if="node.bare_metal.online" style="color: #00BB00;">{{ $t('GlobalField.State.Online') }}</span>
                      <span v-else style="color: red;">{{ $t('GlobalField.State.Offline') }}</span>
                    </vs-tooltip>
                  </div>
                  <div class="col-md-2"><span>{{ node.bare_metal.pm_address }}</span></div>
                  <div class="col-md-1">
                    <router-link class="jimv-link" :to="{ name: 'Instances', query: { keyword: node.node_name }}">
                      <span>{{ node.count.all_vcpu }}/{{ node.cpu }}</span>
                    </router-link>
                  </div>
                  <div class="col-md-1">
                    <router-link class="jimv-link" :to="{ name: 'Instances', query: { keyword: node.node_name }}">
                      <span>{{ node.count.all_instances }}</span>
                    </router-link>
                  </div>
                  <div class="col-md-1"><span>{{ (node.system_load[0] / node.cpu).toFixed(2) }}</span></div>
                  <div class="col-md-1"><span>{{(((node.memory - node.memory_available) / node.memory) * 100).toFixed(0) }}%</span></div>
                  <div class="col-md-1">
                    <a :class="['jimv-link', 'jimv-link-text-danger']" @click="launchRemoveNodesModal($event, ha_group, node)">{{ $t('Button.Delete') }}</a>
                  </div>
                </div>
              </td>
              <td v-else>
                <div class="m-0">
                  <div class="col-md-11 m-0">
                  </div>
                  <div class="col-md-1 m-0">
                    <a :class="['jimv-link', 'jimv-link-text-danger']" @click="launchDeleteHAGroupModal($event, ha_group)">{{ $t('Button.Delete') }}</a>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table v-middle border" style="border-top-width: 0; position: sticky; bottom: 0;">
            <tfoot>
            <tr>
              <td style="display: none;"></td>
              <td><vs-checkbox size="small" v-model="ha_groupsCheckedStateOfAll" @change="changeAllHAGroupsCheckedState($event, !ha_groupsCheckedStateOfAll)"></vs-checkbox></td>
              <td colspan="4">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center justify-content-between" style="width: 140px;">
                    <vs-button size="small" color="#696969" type="border" :disabled="!ha_groupsCheckedState" @click="launchEnableHAGroupsModal">{{ $t('Button.Enable') }}</vs-button>
                    <vs-button size="small" color="#696969" type="border" :disabled="!ha_groupsCheckedState" @click="launchDisableHAGroupsModal">{{ $t('Button.Disable') }}</vs-button>
                  </div>
                  <div class="d-flex align-items-center justify-content-end">
                    <div style="padding-right: 60px; color: #999999; font-size: 12px;" class="d-flex align-items-center justify-content-start">
                      <span>{{ $t('GlobalField.Pagination.TotalItemsPartA') }}&nbsp;{{ ha_groupsShadow.length }}&nbsp;{{ $t('GlobalField.Pagination.TotalItemsPartB') }}&nbsp;{{ $t('GlobalField.Pagination.PrePagePartA') }}&nbsp;</span>
                      <multiselect
                          class="page_size"
                          v-model="pageSize"
                          placeholder=""
                          :searchable="false"
                          :show-labels="false"
                          :max-height="160"
                          :options="pageSizes">
                        <template slot="singleLabel" slot-scope="{ option }">
                          {{ option }}
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <div class="d-flex align-items-center justify-content-start">
                            <span style="margin-left: 8px;">{{ option }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <span>&nbsp;{{ $t('GlobalField.Pagination.PrePagePartB') }}</span>
                    </div>
                    <div class="con-pagination">
                      <vs-pagination :max="9" :total="Math.ceil(ha_groupsShadow.length / pageSize)" v-model="page"></vs-pagination>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </vs-card>
    </vs-col>

    <vs-popup
        :title="$t('HAGroup.Modal.Create.Title')"
        :active.sync="activeCreateHAGroupModal"
        class="create-ha-group-modal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <span style="color: red;">*</span>
            <vs-icon icon="recent_actors"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Name') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <vs-input class="w-100" v-model="HAGroup.name"/>
          </vs-col>
        </vs-row>
        <vs-row class="d-flex align-items-center">
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <vs-icon icon="check_circle"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Active') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <vs-checkbox class="justify-content-start" v-model="HAGroup.active" />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <vs-icon icon="description"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Remark') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <vs-textarea class="w-100 ma-0" v-model="HAGroup.remark" />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="primary" type="filled" style="width: 100%; display: inline-block;" @click="createHAGroup($event)">{{ $t('Button.Submit') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeCreateHAGroupModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
        :title="$t('HAGroup.Modal.Change.Title')"
        :active.sync="activeChangeHAGroupModal"
        class="change-ha-group-modal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <span style="color: red;">*</span>
            <vs-icon icon="recent_actors"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Name') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <vs-input class="w-100" v-model="HAGroup.name"/>
          </vs-col>
        </vs-row>
        <vs-row class="d-flex align-items-center">
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <vs-icon icon="check_circle"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Active') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <vs-checkbox class="justify-content-start" v-model="HAGroup.active" />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <vs-icon icon="description"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Remark') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <vs-textarea class="w-100 ma-0" v-model="HAGroup.remark" />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="primary" type="filled" style="width: 100%; display: inline-block;" @click="updateHAGroup($event)">{{ $t('Button.Update') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeChangeHAGroupModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
        :title="$t('HAGroup.Modal.Delete.Title')"
        :active.sync="activeDeleteHAGroupModal"
        class="delete-ha-group-modal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="10" vs-offset="1" class="form-label">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Modal.Delete.Tip') }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="2" vs-offset="1" class="form-label d-flex align-items-start justify-content-start">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.Name') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <label class="vs-input--label mb-0" style="color: red;">{{ HAGroup.name }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="danger" type="filled" style="width: 100%; display: inline-block;" @click="deleteHAGroup">{{ $t('Button.Delete') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeDeleteHAGroupModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
        :title="$t('HAGroup.Modal.AddNodes.Title')"
        :active.sync="activeAddNodesModal"
        class="add-nodes-modal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="3" vs-offset="1" class="form-label">
            <span style="color: red;">*</span>
            <vs-icon icon="workspaces"></vs-icon>
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.HAGroup') }}</label>
          </vs-col>
          <vs-col vs-w="7" vs-type="flex" vs-justify="start" vs-align="center">
            <multiselect
                v-model="selectedHAGroup"
                track-by="id"
                label="name"
                :searchable="true"
                :show-labels="false"
                :disabled="HAGroups.length === 0"
                :max-height="160"
                @select="HAGroupChose"
                :options="HAGroups">
              <template slot="singleLabel" slot-scope="{ option }">
                <strong style="margin-left: 16px; vertical-align: middle;">{{ option.name }}</strong>
              </template>
              <template slot="option" slot-scope="{ option }">
                <div class="d-flex">
                </div>
                <div class="d-flex">
                  <span style="margin-left: 16px; vertical-align: middle;">{{ option.name }}</span>
                  <span class="ml-auto" style="vertical-align: bottom; font-size: 80%; color: #c2c2c2;">{{ option.create_time / 1000 | datetime('YYYY-MM-DD') }}</span>
                </div>
              </template>
            </multiselect>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="10" vs-offset="1" class="form-label d-flex flex-row align-items-start justify-content-start">
            <div class="w-50">
              <div class="d-flex align-items-center justify-content-start">
                <vs-input icon-no-border class="search-input radius-0 mx-0 my-0 w-100" type="search" v-model="unboundNodesKeyword"/>
              </div>
              <div class="d-flex align-items-start justify-content-start list-box mt-2">
                <ul>
                  <li v-for="node in unboundNodesShadow" :key="node.node_id" @click="toBoundList(node)">{{ node.node_name }} / {{ node.ip }} / {{ node.bare_metal.pm_address }}</li>
                </ul>
              </div>
            </div>
            <div class="h-100 d-flex flex-column align-items-center justify-content-center mx-2">
              <vs-icon icon="keyboard_double_arrow_right" style="font-size: 24px; cursor: pointer;" :class="[unboundNodesShadow.length === 0 ? 'jimv-link-disabled' : '']" @click="allToBoundList"></vs-icon>
              <vs-icon icon="sync_alt" style="font-size: 24px; color: lightgray;" class="my-4"></vs-icon>
              <vs-icon icon="keyboard_double_arrow_left" style="font-size: 24px; cursor:pointer;" :class="[boundNodesShadow.length === 0 ? 'jimv-link-disabled' : '']" @click="allToUnboundList"></vs-icon>
            </div>
            <div class="w-50">
              <div class="d-flex align-items-center justify-content-start">
                <vs-input icon-no-border class="search-input radius-0 mx-0 my-0 w-100" type="search" v-model="boundNodesKeyword"/>
              </div>
              <div class="d-flex align-items-start justify-content-start list-box mt-2">
                <ul>
                  <li v-for="node in boundNodesShadow" :key="node.node_id" @click="toUnboundList(node)">{{ node.node_name }} / {{ node.ip }} / {{ node.bare_metal.pm_address }}</li>
                </ul>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="primary" type="filled" style="width: 100%; display: inline-block;" :disabled="BoundNodes.length < 1" @click="addNodesToHAGroup">{{ $t('Button.Submit') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeAddNodesModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
        :title="$t('HAGroup.Modal.RemoveNodes.Title')"
        :active.sync="activeRemoveNodesModal"
        class="remove-nodes-modal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="10" vs-offset="1" class="form-label">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Modal.RemoveNodes.Tip') }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="2" vs-offset="1" class="form-label d-flex align-items-start justify-content-start">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.HAGroup') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <label class="vs-input--label mb-0" style="color: red;">{{ HAGroup.name }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="2" vs-offset="1" class="form-label d-flex align-items-start justify-content-start">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.ComputeNode') }}</label>
          </vs-col>
          <vs-col vs-w="7">
            <label class="vs-input--label mb-0" style="color: red;">{{ Node.node_name }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="danger" type="filled" style="width: 100%; display: inline-block;" @click="removeNodes">{{ $t('Button.Delete') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeRemoveNodesModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
        :title="$t('HAGroup.Modal.EnableHAGroups.Title')"
        :active.sync="activeEnableHAGroupsModal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="10" vs-offset="1" class="form-label">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.TotalSelectedPartA') }} {{ selectedHAGroups.length }} {{ $t('HAGroup.Field.TotalSelectedPartB') }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-offset="1" vs-w="10">
            <div style="height: 200px; background-color: #f8f9fa; overflow: scroll;" class="d-flex flex-column align-items-start flex-nowrap justify-content-start">
              <label class="vs-input--label mb-0" style="color: black; font-weight: 100;" v-for="(_ha_group, index) in selectedHAGroups" :key="_ha_group.id">{{ index+1 }}: {{ _ha_group.name }}/{{ _ha_group.remark }}</label>
            </div>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="primary" type="filled" style="width: 100%; display: inline-block;" :disabled="!ha_groupsCheckedState" @click="enableHAGroups">{{ $t('Button.Yes') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeEnableHAGroupsModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
        :title="$t('HAGroup.Modal.DisableHAGroups.Title')"
        :active.sync="activeDisableHAGroupsModal">
      <div class="px-6 jimv-modal">
        <vs-row>
          <vs-col vs-w="10" vs-offset="1" class="form-label">
            <label class="vs-input--label mb-0">{{ $t('HAGroup.Field.TotalSelectedPartA') }} {{ selectedHAGroups.length }} {{ $t('HAGroup.Field.TotalSelectedPartB') }}</label>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-offset="1" vs-w="10">
            <div style="height: 200px; background-color: #f8f9fa; overflow: scroll;" class="d-flex flex-column align-items-start flex-nowrap justify-content-start">
              <label class="vs-input--label mb-0" style="color: black; font-weight: 100;" v-for="(_ha_group, index) in selectedHAGroups" :key="_ha_group.id">{{ index+1 }}: {{ _ha_group.name }}/{{ _ha_group.remark }}</label>
            </div>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="7">
          </vs-col>
          <vs-col vs-w="4" class="d-flex">
            <vs-button color="primary" type="filled" style="width: 100%; display: inline-block;" :disabled="!ha_groupsCheckedState" @click="disableHAGroups">{{ $t('Button.Yes') }}</vs-button>
            <vs-button color="dark" type="border" style="width: 100%; display: inline-block;" class="jimv-btn-no-transition" @click="activeDisableHAGroupsModal = false">{{ $t('Button.Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

  </vs-row>
</template>

<script>
import {exchange_b64img, getB64Image} from '@/components/utils/utils';
import {OSTemplateImageTagImportFrom, ISOImageImportFrom, OSTemplateImageKind, JimVEdition} from '@/components/model/status';
import {settings} from "../../variables";
import Multiselect from 'vue-multiselect'

export default {
  name: "HAGroupList",
  components: {
    Multiselect
  },
  props: {
    tab: {
      type: String,
      default: null
    }
  },
  data: ()=>({
    activeCreateHAGroupModal: false,
    activeChangeHAGroupModal: false,
    activeDeleteHAGroupModal: false,
    activeAddNodesModal: false,
    activeRemoveNodesModal: false,
    activeEnableHAGroupsModal: false,
    activeDisableHAGroupsModal: false,
    refresh_ha_groups_timer: null,
    keyword: '',
    unboundNodesKeyword: '',
    boundNodesKeyword: '',
    page: 1,
    pageSize: 50,
    pageSizes: [20, 50, 100, 200, 500],
    HAGroups: [],
    UnboundNodes: [],
    BoundNodes: [],
    selectedHAGroup: null,
    Node: {
      node_id: ''
    },
    struct: {
      HAGroup: {
        name: '',
        active: true,
        remark: '',
      },
    },
    HAGroup: {
      uuid: '',
      name: '',
      active: true,
      remark: '',
    }
  }),
  methods: {
    getHAGroups: function (event) {
      let order_by = 'id';
      let order = 'desc';

      if (this.$route.query.order_by) {
        order_by = this.$route.query.order_by;
      }

      if (this.$route.query.order) {
        order = this.$route.query.order;
      }

      let args = [
        'order_by=' + order_by,
        'order=' + order
      ].join('&')

      let url = '/api/ha_groups?' + args;

      this.$http.get(url)
          .then(response => {
            this.HAGroups = response.data.data;
            this.HAGroups.map(function (item) {
              item.checked = false;
              return item;
            });
          })
          .catch(error => {
            console.error(error);
            console.error(event);
            this.$AlertBus.$emit('alert', { text: error, color: 'danger' });
          });
    },
    refresh_ha_groups_list: function () {
      this.refresh_ha_groups_timer = setTimeout(() => {
        if (!this.ha_groupsCheckedState) {
          this.getHAGroups();
        }
        this.refresh_ha_groups_list();
        // 每6秒刷新列表。
      }, 6000);
    },
    launchCreateHAGroupModal: function (event) {
      this.HAGroup = JSON.parse(JSON.stringify(this.struct.HAGroup));
      this.activeCreateHAGroupModal = true;
    },
    createHAGroup: function (event) {
      let url = '/api/ha_group';

      let config = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        }
      };

      let payload = {
        name: this.HAGroup.name,
        remark: this.HAGroup.remark,
        active: Boolean(this.HAGroup.active),
      };

      this.$http.post(url, payload, config)
          .then(response => {
            this.$AlertBus.$emit('alert', { text: 'Create success.', color: 'success' });
          })
          .catch(error => {
            console.log(error.response);
            this.$AlertBus.$emit('alert', { text: error, color: 'warning' });
          })
          .finally(() => {
            this.activeCreateHAGroupModal = false;
            this.getHAGroups();
          });
    },
    launchChangeHAGroupModal: function (event, ha_group) {
      this.HAGroup = ha_group;
      this.activeChangeHAGroupModal = true;
    },
    updateHAGroup: function (event) {
      let url = '/api/ha_groups/' + this.HAGroup.uuid;

      let config = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        }
      };

      let payload = {
        name: this.HAGroup.name,
        remark: this.HAGroup.remark,
        active: Boolean(this.HAGroup.active),
      };

      this.$http.patch(url, payload, config)
          .then(response => {
            this.$AlertBus.$emit('alert', { text: 'Update success.', color: 'success' });
          })
          .catch(error => {
            console.log(error.response);
            this.$AlertBus.$emit('alert', { text: error, color: 'warning' });
          })
          .finally(() => {
            this.activeChangeHAGroupModal = false;
            this.getHAGroups();
          });
    },
    launchDeleteHAGroupModal: function (event, ha_group) {
      this.HAGroup = ha_group;
      this.activeDeleteHAGroupModal = true;
    },
    deleteHAGroup: function () {
      let url = '/api/ha_group/' + this.HAGroup.uuid;

      return this.$http.delete(url)
          .then(response => {
            this.$AlertBus.$emit('alert', { text: 'Directive sent success.', color: 'success' });
          })
          .catch(error => {
            console.log(error.response);
            this.$AlertBus.$emit('alert', { text: error, color: 'warning' });
          })
          .finally(() => {
            this.activeDeleteHAGroupModal = false;
            this.getHAGroups();
          });
    },
    launchAddNodesModal: function (event) {
      this.selectedHAGroup = null;
      this.UnboundNodes = [];
      this.BoundNodes = [];
      this.activeAddNodesModal = true;
    },
    getBindableNodes: function (uuid) {
      let url = '/api/ha_groups/_bindable_nodes/' + uuid;

      this.$http.get(url)
          .then(response => {
            this.UnboundNodes = response.data.data;
          })
          .catch(error => {
            console.error(error);
            console.error(event);
            this.$AlertBus.$emit('alert', { text: error, color: 'danger' });
          });
    },
    HAGroupChose:function (ha_group) {
      this.getBindableNodes(ha_group.uuid);
    },
    toBoundList: function (node) {
      let _node = this.UnboundNodes.filter(item => item.node_id === node.node_id)[0];
      let index = this.UnboundNodes.indexOf(_node);
      this.UnboundNodes.splice(index, 1);
      this.BoundNodes.splice(0, 0, _node);
    },
    toUnboundList: function (node) {
      let _node = this.BoundNodes.filter(item => item.node_id === node.node_id)[0];
      let index = this.BoundNodes.indexOf(_node);
      this.UnboundNodes.splice(0, 0, _node);
      this.BoundNodes.splice(index, 1);
    },
    allToBoundList: function () {
      this.BoundNodes = this.BoundNodes.concat(this.UnboundNodes.filter((item) => this.BoundNodes.indexOf(item) === -1))
      this.UnboundNodes = [];
    },
    allToUnboundList: function () {
      this.UnboundNodes = this.UnboundNodes.concat(this.BoundNodes.filter((item) => this.UnboundNodes.indexOf(item) === -1))
      this.BoundNodes = [];
    },
    addNodesToHAGroup: function () {
      let nodes_id = this.BoundNodes.map((item) => { return item.node_id; })
      let url = '/api/ha_group/_add_nodes/' + this.selectedHAGroup.uuid + '/' + nodes_id.join(',');

      this.$http.put(url)
          .then(response => {
            this.$AlertBus.$emit('alert', {text: 'Directive sent success.', color: 'success'});
          })
          .catch(error => {
            console.error(error);
            console.error(event);
            this.$AlertBus.$emit('alert', { text: error, color: 'danger' });
          })
          .finally(() => {
            this.getHAGroups();
            this.activeAddNodesModal = false;
          });
    },
    launchRemoveNodesModal: function (event, ha_group, node) {
      this.HAGroup = ha_group;
      this.Node = node;
      this.activeRemoveNodesModal = true;
    },
    removeNodes: function () {
      let url = '/api/ha_group/_remove_nodes/' + this.HAGroup.uuid + '/' + this.Node.node_id;

      return this.$http.delete(url)
          .then(response => {
            this.$AlertBus.$emit('alert', { text: 'Directive sent success.', color: 'success' });
          })
          .catch(error => {
            console.log(error.response);
            this.$AlertBus.$emit('alert', { text: error, color: 'warning' });
          })
          .finally(() => {
            this.activeRemoveNodesModal = false;
            this.getHAGroups();
          });
    },
    changeAllHAGroupsCheckedState: function (event, state) {
      this.ha_groupsShadow.slice(this.pageSize * (this.page - 1), this.pageSize * this.page).map((ele) => {
        ele.checked = state
        this.$set(this.HAGroups, this.HAGroups.indexOf(ele), ele);
      })
    },
    changeHAGroupCheckedState: function (event, ha_group) {
      let _ha_group = this.HAGroups.filter(item => item.id === ha_group.id)[0];
      let index = this.HAGroups.indexOf(_ha_group);
      this.$set(this.HAGroups, index, ha_group);
    },
    launchEnableHAGroupsModal: function (event) {
      this.activeEnableHAGroupsModal = true;
    },
    enableHAGroups: function (event) {
      let uuids = this.selectedHAGroups.map((item) => { return item.uuid; })
      let url = '/api/ha_groups/' + uuids.join(',');

      let config = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        }
      };

      let payload = {
        active: true,
      };

      return this.$http.patch(url, payload, config)
          .then(response => {
            this.$AlertBus.$emit('alert', { text: 'Directive sent success.', color: 'success' });
          })
          .catch(error => {
            console.log(error.response);
            this.$AlertBus.$emit('alert', { text: error, color: 'warning' });
          })
          .finally(() => {
            this.activeEnableHAGroupsModal = false;
            this.getHAGroups();
          });
    },
    launchDisableHAGroupsModal: function (event) {
      this.activeDisableHAGroupsModal = true;
    },
    disableHAGroups: function (event) {
      let uuids = this.selectedHAGroups.map((item) => { return item.uuid; })
      let url = '/api/ha_groups/' + uuids.join(',');

      let config = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        }
      };

      let payload = {
        active: false,
      };

      return this.$http.patch(url, payload, config)
          .then(response => {
            this.$AlertBus.$emit('alert', { text: 'Directive sent success.', color: 'success' });
          })
          .catch(error => {
            console.log(error.response);
            this.$AlertBus.$emit('alert', { text: error, color: 'warning' });
          })
          .finally(() => {
            this.activeDisableHAGroupsModal = false;
            this.getHAGroups();
          });
    },
  },
  computed: {
    ha_groupsShadow() {
      let ha_groups = [];
      let keyword = this.keyword.toLowerCase();

      for (const ha_group of this.HAGroups) {
        if (ha_group.name.toLowerCase().includes(keyword)) {
          ha_groups.push(ha_group);
        }
      }

      return ha_groups;
    },
    ha_groupsCheckedStateOfAll: {
      get: function () {
        let ha_groups = this.ha_groupsShadow.slice(this.pageSize * (this.page - 1), this.pageSize * this.page).filter(item => item.checked === false);
        return ha_groups.length === 0 && this.ha_groupsShadow.length > 0;
      },
      set: function (val) {
      }
    },
    ha_groupsCheckedState: {
      get: function () {
        let ha_groups = this.ha_groupsShadow.slice(this.pageSize * (this.page - 1), this.pageSize * this.page).filter(item => item.checked === true);
        return ha_groups.length > 0;
      },
      set: function (val) {
      }
    },
    selectedHAGroups() {
      return this.ha_groupsShadow.filter(item => item.checked === true);
    },
    boundNodesShadow() {
      let lower_case_keyword = this.boundNodesKeyword.toLowerCase();
      return this.BoundNodes.filter((item) => {
        return (
            item.node_name.toLowerCase().includes(lower_case_keyword) ||
            item.ip.toLowerCase().includes(lower_case_keyword) ||
            item.bare_metal.pm_address.toLowerCase().includes(lower_case_keyword)
        )
      });
    },
    unboundNodesShadow() {
      let lower_case_keyword = this.unboundNodesKeyword.toLowerCase();
      return this.UnboundNodes.filter((item) => {
        return (
            item.node_name.toLowerCase().includes(lower_case_keyword) ||
            item.ip.toLowerCase().includes(lower_case_keyword) ||
            item.bare_metal.pm_address.toLowerCase().includes(lower_case_keyword)
        )
      });
    },
  },
  watch: {
  },
  beforeMount() {
  },
  mounted() {
    this.getHAGroups();
    this.refresh_ha_groups_list();
  },
  beforeDestroy() {
    clearTimeout(this.refresh_ha_groups_timer);
  },
}
</script>

<style lang="scss" scoped>
::v-deep.multiselect.page_size, .multiselect.page_size.multiselect--active {
  margin: 0;
  width: 54px;
  .multiselect__placeholder,
  .multiselect__input,
  .multiselect__tags,
  .multiselect__current,
  .multiselect__select,
  .multiselect__option--selected,
  .multiselect__single,
  .multiselect__content-wrapper,
  .multiselect__content {
    min-height: unset;
    font-size: 0.7rem !important;
    font-weight: unset;
    border-radius: 0;
    line-height: unset;

    margin-left: 0;
    margin-top: 2px;
    margin-bottom: 2px;
    //border: 1px solid rgba(0, 0, 0, 0.04) !important;
    .multiselect__option--highlight {
      background-color: #f8f9fa;
      color: #3e5569;
    }
  }

  .multiselect__single {
    text-align: center;
    padding-left: 0;
    padding-right: 13px;
  }

  .multiselect__select {
    height: 20px;
    width: 20px;
    z-index: 1000;
  }

  .multiselect__select:before {
    top: 54%;
    border-width: 3px 3px 0;
  }

  .multiselect--disabled {
    .multiselect__select {
      //height: 27px;
      padding-bottom: 8px;
    }
  }

  .multiselect__content-wrapper {
    width: 54px;
    //border: 1px solid rgba(0, 0, 0, 0.04) !important;
  }

  .multiselect__tags {
    padding: 0;
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
  }

  .multiselect__option {
    padding: 2px;
    min-height: 16px;
  }
}

::v-deep.con-vs-tabs .con-slot-tabs {
  margin-top: 10px;
}

::v-deep.ha-groups-center-panel {
  min-height: 680px;

  table {
    font-size: 12px;
    width: 100%;
    border-color: #dfe8f1;
    border-style: solid;
    border-width: 1px;
    margin-bottom: 0;
    background: white;

    .con-pagination {
      padding-right: 50px;
    }
    .vs-pagination--buttons, .vs-pagination--li {
      width: 30px;
      height: 30px;
    }
    .vs-pagination--ul, .vs-pagination--li .effect {
      border-radius: 0;
    }
    .vs-pagination--ul {
      padding: 0;
    }
    thead {
      tr:nth-child(2) {
        line-height: 40px;
        border-style: solid;
        border-width: 0 0 2px 0;

        th {
          text-align: left;
          padding: 6px 0;
        }
        th:nth-child(2) {
          vertical-align: middle;
          width: 60px;
        }
        th:nth-child(3) {
          width: 100px;
        }
        th:nth-child(4) {
          width: 40px;
        }
        th:last-child {
          div {
            display: flex;
            width: 100%;
            justify-content: center;
            flex-wrap: nowrap;
            margin: auto;
          }

          div:first-child {
            padding-left: 0;
          }

          div:nth-last-child(-n+5) {
            text-align: center;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          text-align: left;
          vertical-align: middle;
          border-color: #dfe8f1;
          border-style: solid;
          border-width: 1px 0 0 0;
        }
        td:nth-child(2) {
          text-align: center;
          width: 60px;
        }
        th:nth-child(3) {
          width: 100px;
        }
        th:nth-child(4) {
          width: 40px;
        }
        td:last-child {
          div {
            display: flex;
            width: 100%;
            justify-content: space-between;
            flex-wrap: nowrap;
            margin: auto;
            div {
              display: flex;
              justify-content: center;
            }
          }

          div:first-child {
            padding-left: 0;
          }
        }
      }
      tr:hover td {
        color: #3e5569;
        background-color: #f8f9fa;
        .edit_label_icon {
          display: unset;
          background-color: white;
          width: 20px;
          height: 20px;
          margin: auto 0;
          padding: 2px;
          border-radius: 0;
          border-width: 1px;
          border-style: solid;
          border-color: #dfe8f1;
        }
      }
      tr td {
        .edit_label_icon {
          display: none;
        }
      }
    }
    tfoot {
      height: 100px;
      //background-color: #F5F6FA;
      border-color: #dfe8f1;
      border-style: solid;
      border-width: 1px;
      text-align: left;
      padding: 0;
      tr {
        td,
        th {
          vertical-align: middle;
        }
        td:nth-child(2) {
          text-align: center;
          width: 60px;
        }
        td:nth-child(3) {
          padding-left: 0;
        }
      }
    }
  }
}

::v-deep.jimv-btn-group {
  .vs-icon {
    transform: rotate(0.13turn);
  }
}

::v-deep.jimv-modal {
  .vs-row {
    margin: 20px 0;

    .vs-icon {
      font-size: 18px;
      color: rgba(var(--vs-primary), 1);
    }

    .vs-con-textarea {
      margin-bottom: 0;
    }

    .vs-button {
      padding: 5px 10px;
      margin: 10px 2px;
    }
  }
}
::v-deep.form-label {
  display: -webkit-box;
  flex-direction: column;
  justify-content: center;
  label {
    color: #2b2b2b;
    opacity: 0.8;
  }
}
::v-deep.remove-nodes-modal,
::v-deep.create-ha-group-modal,
::v-deep.delete-ha-group-modal,
::v-deep.change-ha-group-modal {
  .vs-checkbox {
    width: 12px;
    height: 12px;
    .vs-icon {
      color: white !important;
      font-size: 12px;
      height: 8px;
    }
  }
}

::v-deep.search-input {
  width: 260px;
  input {
    width: -webkit-fill-available;
  }
}

::v-deep.add-nodes-modal {
  .vs-popup {
    width: 800px;
  }
}

::v-deep.list-box {
  width: 100%;
  height: 300px;
  border: lightgrey solid 1px;
  overflow-y: auto;
  //box-shadow: inset 0 1px 1px rgba(var(--vs-primary), 1), 0 0 8px rgba(var(--vs-primary), 1);

  ul {
    width: 100%;

    li {
      display: flex;
      align-items: center;
      height: 40px;
      cursor: pointer;
      border-bottom: rgba(lightgrey, 0.4) solid 1px;
      color: #2b2b2b;
      padding: 0 20px;
    }
    li:hover {
      //background-color: lightskyblue;
      background-color: rgba(var(--vs-primary), 1);
      color: white;
    }
  }
}
</style>
